var map = {
	"./Cisco.png": 7596,
	"./L&T.png": 2793,
	"./L&T2.png": 4087,
	"./atos syntel.png": 2450,
	"./capgemini.png": 7344,
	"./dell.png": 7011,
	"./ericsson.png": 1408,
	"./genpact.png": 8593,
	"./hcl.png": 745,
	"./hexaware.png": 9924,
	"./hp.png": 5562,
	"./infosys.png": 7627,
	"./intel.png": 6725,
	"./microsoft.png": 6289,
	"./mindfire.png": 1460,
	"./mindtree.png": 3342,
	"./niit.png": 3925,
	"./nokia.png": 3276,
	"./oracle.png": 7429,
	"./paytm.png": 7715,
	"./persistent.png": 858,
	"./rolta.png": 1750,
	"./sap.png": 1185,
	"./sonata.png": 7882,
	"./tata.png": 5648,
	"./tcs.png": 9777,
	"./techmahindra.png": 6397,
	"./twitter.png": 683,
	"./virtusa.png": 4491,
	"./zoho.png": 9040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5249;